/**
 * Agent <-> specialist message thread. Reused on the staff submission detail and
 * the agent's code+PIN view. `me` controls which side's bubbles align right.
 */
import type { Message } from '@commpass/shared';
import { useState } from 'react';
import { SendIcon } from './Icons';

export function Messages({
  messages,
  me,
  onSend,
  busy,
}: {
  messages: Message[];
  me: 'agent' | 'staff';
  onSend: (text: string) => Promise<void> | void;
  busy?: boolean;
}) {
  const [text, setText] = useState('');

  async function send() {
    const t = text.trim();
    if (!t) return;
    await onSend(t);
    setText('');
  }

  return (
    <div className="panel">
      <div className="panel-head">
        <h3>Messages</h3>
        <span style={{ fontSize: 12, color: 'var(--muted)' }}>
          {me === 'staff' ? 'The agent is emailed when you post' : 'AAS is emailed when you post'}
        </span>
      </div>
      <div className="panel-pad">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14 }}>
          {messages.length === 0 && <div className="sub-meta">No messages yet.</div>}
          {messages.map((msg) => {
            const mine = msg.from === me;
            return (
              <div key={msg.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start' }}>
                <div
                  style={{
                    maxWidth: '80%',
                    background: mine ? 'var(--navy)' : 'var(--slate-soft)',
                    color: mine ? '#fff' : 'var(--text)',
                    borderRadius: 12,
                    padding: '9px 13px',
                    fontSize: 13.5,
                    lineHeight: 1.45,
                  }}
                >
                  <div style={{ whiteSpace: 'pre-wrap' }}>{msg.text}</div>
                  <div style={{ fontSize: 10.5, opacity: 0.7, marginTop: 4 }}>
                    {msg.from === 'staff' ? 'AAS' : msg.author || 'Agent'} · {new Date(msg.at).toLocaleString()}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
          <textarea
            className="finput"
            rows={2}
            placeholder="Write a message…"
            value={text}
            onChange={(e) => setText(e.target.value)}
            style={{ flex: 1, resize: 'vertical' }}
          />
          <button className="btn btn-primary" onClick={() => void send()} disabled={busy || !text.trim()}>
            <SendIcon width={16} height={16} /> Send
          </button>
        </div>
      </div>
    </div>
  );
}
